import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import ClassNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FilterContext from 'components/HelpMe/FilterContext';
import Types from './Types';
import Topics from './Topics';

const useStyles = makeStyles(theme => ({
  root: {
    height: 105,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'rgba(1, 97, 155, 0.9)',
    alignItems: 'center',
    [theme.breakpoints.down('600')]: {
      height: '255px !important',
    },
  },
  landingPage: {
    height: 105,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    alignItems: 'center',
    [theme.breakpoints.down('600')]: {
      height: '255px !important',
    },
  },
  topics: {
    marginBottom: 12,
    marginTop: 24,
  },
  buttonWrapper: {
    display: 'flex',
    marginTop: 18,
  },
  button: {
    ...theme.typography.button,
    color: '#fff',
    boxShadow: 'none',
    width: 178,
    height: 52,
    borderRadius: 5,
    zIndex: 9,
  },
  goBtn: {
    backgroundColor: `${theme.palette.primary.main} !important`,
  },
  searchBtn: {
    backgroundColor: '#E8F1F5',
    color: '#13619B',
  },
}));

function Content() {
  const classes = useStyles();
  const {
    changeFilter,
    mediaTypes,
    selectedMediaType,
    go,
    selectedTopicSlug,
    through,
    isModal,
  } = useContext(FilterContext);
  if (isModal) {
    return (
      <Grid container spacing={2} justify="space-between">
        <Grid item xs={12} sm={12} md={4}>
          <Topics />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Types
            data={mediaTypes}
            value={selectedMediaType}
            changeHandler={changeFilter}
            label={through}
            isModal={isModal}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Button
            variant="contained"
            className={ClassNames(classes.button, classes.goBtn)}
            onClick={go}
            disabled={!selectedTopicSlug || !selectedMediaType}
          >
            GO
          </Button>
        </Grid>
      </Grid>
    );
  }
  return (
    <>
      <Grid item xs={12} className={classes.topics}>
        <Topics />
      </Grid>
      <Grid item xs={12}>
        <Types
          data={mediaTypes}
          value={selectedMediaType}
          changeHandler={changeFilter}
          label={through}
          isModal={isModal}
        />
      </Grid>
      <Grid item xs={12} className={classes.buttonWrapper}>
        <Button
          variant="contained"
          className={ClassNames(classes.button, classes.searchBtn)}
          onClick={go}
          disabled={!selectedTopicSlug || !selectedMediaType}
        >
          SEARCH
        </Button>
      </Grid>
    </>
  );
}

export default Content;
